import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusquedaObrasProcesoComponent } from './components/busqueda-obras-proceso/busqueda-obras-proceso.component';
import { BuscadorCapasComponent } from './components/buscador-capas/buscador-capas.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MultiSelectModule } from 'primeng/multiselect';
import { AppRoutingModule } from 'src/app/core/app-routing.module';
import { TooltipModule } from 'primeng/tooltip';
import { BusquedaObrasPlaneacionComponent } from './components/busqueda-obras-planeacion/busqueda-obras-planeacion.component';
import { CarpetaEjecutivaModule } from '../carpeta-ejecutiva/carpeta-ejecutiva.module';
import { ObrasModule } from '../obras/obras.module';
import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { CheckboxModule } from 'primeng/checkbox';
import { DetalleObraComponent } from './components/detalle-obra/detalle-obra.component';
import { BusquedasModule } from '../busquedas/busquedas.module';
import {ProgressSpinnerModule} from 'primeng/progressspinner';

@NgModule({
  declarations: [
    BusquedaObrasProcesoComponent,
    BuscadorCapasComponent,
    BusquedaObrasPlaneacionComponent,
    DetalleObraComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AgmCoreModule,
    ReactiveFormsModule,
    CalendarModule,
    TableModule,
    DropdownModule,
    ScrollingModule,
    InputSwitchModule,
    MultiSelectModule,
    CheckboxModule,
    TooltipModule,
    AppRoutingModule,
    CarpetaEjecutivaModule,
    ObrasModule,
    BusquedasModule,
    ProgressSpinnerModule
  ],
  exports: [
    BusquedaObrasProcesoComponent,
    BuscadorCapasComponent
  ],
  providers: [
    GoogleMapsAPIWrapper
  ]
})
export class MapasModule { }